import { render } from "./SettingsList.vue?vue&type=template&id=7e19fae9&scoped=true"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"

import "./SettingsList.vue?vue&type=style&index=0&id=7e19fae9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e19fae9"]])

export default __exports__